import * as React from 'react';

import {
  createStyles,
  ITypographyProps,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
  WithStyles,
} from '@nelnet/unifi-components-react';

const styles = () =>
  createStyles({
    paper: {
      marginLeft: '2px',
      marginRight: '2px',
      overflowX: 'auto',
    },
    rowHeader: {
      fontFamily: `Consolas, Menlo, Monaco, 'Andale Mono WT', 'Andale Mono', 'Lucida Console',
        'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono',
        'Nimbus Mono L', 'Courier New', Courier, monospace`,
      fontSize: '.9em',
      fontWeight: 'initial',
    },
  });

interface IPropertyTableProps extends WithStyles<typeof styles> {
  title: string;
  topMargin?: ITypographyProps['margin'];
  headers: string[];
  colWidths: string[];
  // eslint-disable-next-line @typescript-eslint/ban-types
  cellValues: [{}];
}

const UnwrappedPropertyTable: React.FunctionComponent<IPropertyTableProps> = ({
  title,
  topMargin,
  headers,
  colWidths,
  cellValues,
  classes,
}) => {
  const panelMargin = topMargin || { top: 2 };
  return (
    <>
      <Typography variant="h4" margin={panelMargin}>
        {title}
      </Typography>
      <Paper margin={{ y: 2 }} padding={{ x: 1 }} className={classes.paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => {
                const headerWidth = colWidths[index];
                return (
                  <TableCell key={header} style={{ width: headerWidth }}>
                    {header}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {cellValues.map((item) => {
              const values: string[] = Object.values(item);

              const cells: JSX.Element[] = [];

              for (let i = 0; i < headers.length; i++) {
                const rowHeader = i === 0;
                const headerDef = rowHeader && {
                  className: classes.rowHeader,
                };
                const scope = rowHeader ? 'row' : '';
                const cellComponent = rowHeader ? 'th' : 'td';
                const cellValue = values[i] || '';
                let displayValue: JSX.Element = <>{cellValue}</>;
                if (rowHeader && cellValue.includes('*')) {
                  displayValue = <strong>{cellValue}</strong>;
                }
                cells[i] = (
                  <TableCell
                    scope={scope}
                    component={cellComponent}
                    {...headerDef}
                    key={`${values[0]} ${i}`}
                  >
                    {displayValue}
                  </TableCell>
                );
              }

              return <TableRow key={name}>{cells}</TableRow>;
            })}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
};

const PropertyTable = withStyles(styles)(UnwrappedPropertyTable);

export default PropertyTable;
